module.exports = __webpack_public_path__ + "static/media/AdminImg.84f43294.png";